<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pro"> </p>
<p class="Chap-Title-ct"><span href="#/xhtml/contents#c_pro" title="Link target outside of Sample"><span class="ePub-B">PROLOGUE</span></span></p>
<p class="CO"><span class="ePub-I">Sometimes I can barely remember how I got here. The past seems to have shaken loose, faded into overlapping lines on an old Etch A Sketch. Other times every detail comes into sharp focus.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">Even the irony.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">Like how one of my phobias used to be public scrutiny. That was before, of course. Now Nancy Grace screeches my name nightly and the Twitterati come up with clever hashtags to attach to it.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">#SocialWork</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">#AHelpingProfession</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">#NoReally</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">My best friend is a reporter. She keeps telling me this is nothing, that I need to prepare myself for the correspondents who are packing their bags for the trial. They’ll come to Virginia, she says, because the case has it all. Malpractice. Adultery. Class. Race.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">And murder.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">As an added bonus, the political climate has swung back to the right and it’s widely known that my father is a liberal Jewish congressman from New York. Which is pretty much a losing trifecta in certain circles. In fact, just yesterday the Tea Partying governor was quoted as saying that the rosy red apple never falls far from the tree. He seems to have forgotten that his wife and I were first-grade room mothers together. Though she and I never crossed the cordiality zone, we did spend a lot of time together organizing events like the Christmas extravaganza and the underappreciated, labor-intensive Teacher Appreciation Day.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">I tell myself that concentrating on everything but the horror of what happened means that I am coping. I tell myself that if I don’t look down, I’ll be able to maintain my balance. But the tightrope is swinging wildly.</span></p>
<p class="Text-Standard-tx"><span class="ePub-I">And mostly I’m just waiting for a hard wind to blow.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?69696736